import React from "react";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";

export default function LegalLayout({ title, lastUpdated, children, path }) {
    return (
        <Layout>
            <Seo title={title} path={path} />
            <article className="max-w-3xl mx-auto px-4 md:px-8 py-16">
                <div className="font-mono text-xs uppercase tracking-[0.4em] text-primary mb-3">
                    ▌ LEGAL
                </div>
                <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-2">
                    {title}
                </h1>
                <p className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-10">
                    Last updated: {lastUpdated}
                </p>
                <div className="space-y-6 text-zinc-300 leading-relaxed [&_h2]:text-xl [&_h2]:md:text-2xl [&_h2]:font-bold [&_h2]:tracking-tight [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:text-base [&_ul]:list-none [&_ul]:space-y-2 [&_li]:flex [&_li]:gap-2 [&_li]:before:content-['▌'] [&_li]:before:text-primary [&_li]:before:flex-shrink-0">
                    {children}
                </div>
            </article>
        </Layout>
    );
}
